/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
// Formik and Yup
import { useFormik } from "formik";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

//  some date function

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  acceptedBySuid,
  createDynamicColumn,
  getDynamicColumn,
  getRejections,
  getSubModulesByRoleId,
  rejectionBySuid,
} from "../../../../store";

// config file
import Config from "../../../../config/index";

// Cookies
import { Backdrop } from "@mui/material";
import { addMinutes, format } from "date-fns";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Rejections = ({
  acceptedBySuid,
  rejectionBySuid,
  rejectionReducer,
  getRejections,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let subModuleId = "13c26613-8372-4cb1-9dcf-da1388c0a4b5";

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let rejectionsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "13c26613-8372-4cb1-9dcf-da1388c0a4b5",
  );

  let viewRejections = rejectionsModule
    ? rejectionsModule.actionId.includes("8064e6f3-36e4-4b16-8500-3e2e79258352")
    : null;
  let acceptRejectionsAccess = rejectionsModule
    ? rejectionsModule.actionId.includes("e02c986a-7bc6-407b-a39b-dacbb2b54a98")
    : null;
  let rejectionsAccess = rejectionsModule
    ? rejectionsModule.actionId.includes("53fffb21-5b90-4574-853d-9d49776889bd")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const navigate = useNavigate();

  useEffect(() => {
    viewRejections &&
      getRejections(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewRejections, pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      { Header: "SUID", accessor: "sku" },
      { Header: "Item Code", accessor: "itemCode" },
      { Header: "Item Description", accessor: "itemDescription" },
      { Header: "Qty", accessor: "qty" },
      { Header: "Uom", accessor: "uom" },
      { Header: "LOT No", accessor: "lotNumber" },
      { Header: "Serial No", accessor: "serialNumber" },
      { Header: "Reason", accessor: "reason" },
      { Header: "Location", accessor: "locationCode" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempAsset = [];
    let data = rejectionReducer.rejections.data
      ? rejectionReducer.rejections.data
      : [];
    setPaginationObj(rejectionReducer?.rejections?.pagination);
    setLoading(rejectionReducer.loading);
    data.map((reject) => {
      const formatDate = new Date(reject.cd);

      let des = reject?.itemDescription;
      let len = desLength;
      const rejectObject = {
        privateKey: reject.suid,
        sku: reject.suid,
        itemCodeDes: `${reject.itemCode} / ${des ? des.substring(0, len) : ""}`,
        itemDescription: `${des ? des.substring(0, len) : ""}`,
        itemCode: reject.itemCode,
        itemId: reject.itemId,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: reject.cd,
        qty: `${reject.qty}`,
        uom: `${reject.uom} `,
        // lotSerialNo: `${reject.lotNumber ? reject.lotNumber : "NA"} / ${
        //   reject.serialNumber ? reject.serialNumber : "NA"
        // }`,
        lotNumber: reject.lotNumber ? reject.lotNumber : "NA",
        serialNumber: reject.serialNumber ? reject.serialNumber : "NA",
        suid: reject.suid,
        locationCode: reject.locationCode,
        reason: reject.rejectionReason,
      };
      tempAsset.push(rejectObject);
    });

    setState({ ...state, rows: tempAsset });
  }, [rejectionReducer]);

  const [buttonName, setButtonName] = useState("Submit");
  const [denyButtonName, setDenyButtonName] = useState("Deny");

  const [openCreateRejectionsModal, setOpenCreateRejectionsModal] =
    useState(false);

  const handleOpenCreateRejectionsModal = (data = {}) => {
    setOpenCreateRejectionsModal(true);
  };

  const handleCloseCreateRejectionsModal = () => {
    setOpenCreateRejectionsModal(false);
  };

  const createRejectionsHandler = (event, data) => {
    handleOpenCreateRejectionsModal(data);
  };
  const [uncheck, setUncheck] = useState(false);

  const [isErrorMsgForRejection, setIsErrorMsgForRejection] = useState(false);
  const [selectedCreateRejectionsData, setSelectedCreateRejectionsData] =
    useState([]);
  const [isErrorForRejections, setIsErrorRejections] = useState(false);
  const [isSuccessForRejections, setIsSuccessRejections] = useState(false);

  const createRejections = (data) => {
    setSelectedCreateRejectionsData(data);
  };
  const onClickCreateRejectionsList = async () => {
    setDenyButtonName("Please wait...");
    let tempArray = [];
    selectedCreateRejectionsData.map((data) => {
      const tempPayload = {
        suid: data.suid,
      };
      tempArray.push(tempPayload);
    });

    let payload = {
      suids: tempArray,
    };
    let res = await rejectionBySuid(payload, jwtToken);
    if (res.status) {
      setUncheck(!uncheck);
      setIsSuccessRejections(true);
      getRejections(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        setIsSuccessRejections(false);
      }, 2250);
      setTimeout(() => {
        handleCloseCreateRejectionsModal();
        setDenyButtonName("Deny");
      }, 3000);
    }
    if (!res.status) {
      setIsErrorRejections(true);
      setTimeout(() => {
        setIsErrorRejections(false);
      }, 3000);
      setIsErrorMsgForRejection(res?.data?.data?.msg);
      setDenyButtonName("Deny");
    }
  };

  const [isErrorForAllocate, setIsErrorForAllocate] = useState(false);
  const [isSuccessForAllocate, setIsSuccessForAllocate] = useState(false);
  const [errorMsgForAccept, setErrorMsgForAccept] = useState("");

  const submitForAccept = async (values) => {
    setButtonName("Please wait...");
    let tempArray = [];
    selectedCreateRejectionsData.map((data) => {
      const quantity = parseFloat(data.qty);
      const tempPayload = {
        suid: data.suid,
        qty: quantity,
        itemId: data.itemId,
      };
      tempArray.push(tempPayload);
    });

    let payload = {
      // documentNumber: values.documentNumber.trim(),
      suids: tempArray,
    };

    let res = await acceptedBySuid(payload, jwtToken);
    if (res.status) {
      setUncheck(!uncheck);
      setIsSuccessForAllocate(true);
      getRejections(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setIsSuccessForAllocate(false);
      }, 3000);
      setTimeout(() => {
        handleCloseAcceptModal();
        setButtonName("Submit");
      }, 3000);
    }
    if (!res.status) {
      setErrorMsgForAccept(res?.data?.data?.msg);
      setIsErrorForAllocate(true);
      setTimeout(() => {
        setIsErrorForAllocate(false);
      }, 3000);
      setButtonName("Submit");
    }
  };

  const initialValuesForAccept = {
    documentNo: "",
  };
  const formikForAccept = useFormik({
    initialValues: initialValuesForAccept,
    onSubmit: submitForAccept,
  });

  const [acceptModal, setAcceptModal] = useState(false);

  const handleOpenAcceptModal = () => {
    setAcceptModal(true);
    formikForAccept.setValues(initialValuesForAccept);
    formikForAccept.setTouched({});
    formikForAccept.setErrors({});
  };
  const handleCloseAcceptModal = () => {
    setAcceptModal(false);
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getRejections(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };
  return (
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mb={-6}
            ></MDBox>
            <MDBox mt={-1}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  selection={true}
                  uncheckProp={uncheck}
                  options={{ draggable: false }}
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  selectionButtonClick={createRejections}
                  selectionButtonComponent={
                    <>
                      {rejectionsAccess && (
                        <Tooltip title="Deny">
                          <MDButton
                            color="error"
                            type="button"
                            style={{
                              marginTop: "0.5rem",
                              marginLeft: "1rem",
                              marginBottom: "0.8rem",
                            }}
                            onClick={(evt, data) =>
                              createRejectionsHandler(evt, data)
                            }
                          >
                            Deny
                          </MDButton>
                        </Tooltip>
                      )}
                      {acceptRejectionsAccess && (
                        <Tooltip title="Confirm">
                          <MDButton
                            color="success"
                            type="button"
                            style={{
                              marginTop: "0rem",

                              marginLeft: "1rem",
                            }}
                            onClick={(evt, data) =>
                              handleOpenAcceptModal(evt, data)
                            }
                          >
                            Confirm
                          </MDButton>
                        </Tooltip>
                      )}
                    </>
                  }
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={openCreateRejectionsModal}
              onClose={handleCloseCreateRejectionsModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForRelease}>
                <MDTypography>Are you sure you want to Deny?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateRejectionsModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="error"
                    onClick={onClickCreateRejectionsList}
                    disabled={denyButtonName === "Please wait..."}
                  >
                    {denyButtonName}
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessForRejections}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessRejections(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Denied successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorForRejections}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorRejections(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForRejection}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={acceptModal}
              onClose={handleCloseAcceptModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForRelease}>
                <MDTypography>Are you sure you want to confirm ?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseAcceptModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={submitForAccept}
                    disabled={buttonName === "Please wait..."}
                  >
                    Yes
                  </MDButton>
                </MDBox>
                <MDBox>
                  <Collapse in={isErrorForAllocate}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorForAllocate(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsgForAccept}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessForAllocate}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessForAllocate(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Confirmed Successfully
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              style={{ backdropFilter: "blur(5px)" }}
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    rejectionReducer: state.rejectionReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    acceptedBySuid: (payload, jwtToken) =>
      dispatch(acceptedBySuid(payload, jwtToken)),
    rejectionBySuid: (payload, jwtToken) =>
      dispatch(rejectionBySuid(payload, jwtToken)),
    getRejections: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getRejections(pageNo, rowsPerPage, searchObject, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Rejections);
